// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"AIECMS_sectionWrapper__xFl3c"};